<template>
  <div>
    <!-- closeTask: '关闭任务' -->
    <el-dialog :title="$t('message.closeTask')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="380px" center>
      <div class="content">

        <!-- 关闭原因 -->
        <div class="label">
          <span>*</span> {{ $t('message.closeReason') }}:
        </div>
        <div class="remarkRecords">
          <el-input v-model="datas.cancel_reason" type="textarea" placeholder="请输入关闭原因"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 确定 -->
        <el-button type="primary" @click="spotCancel">
          {{ $t("message.ok") }}
        </el-button>
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: {},
      dialogVisible: false
    };
  },
  methods: {
    spotCancel() {
      if (this.datas.cancel_reason.trim() == '') return this.$message.error('请输入关闭原因')
      this.$api.spotCheckApi.spotCancel(this.datas).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$parent.spotList()
      });

    },
  }
}
</script>
<style lang='scss' scoped>
.content {
  padding: 0 15px;
}

.label {
  margin-bottom: 6px;

  span {
    color: #B4272D;
  }

}

.remarkRecords {
  /deep/.el-textarea__inner {
    height: 150px !important;
    resize: none;


  }
}
</style>